export { AmplitudeExperiments, AmplitudeExperimentsContext, FailedAmplitudeExperiments, } from './experiments';
export { AMPLITUDE_OFF_ENROLMENT, ExperimentConfig } from './types';
export { buildAmplitudeExperimentTrackingTrait } from './utils/buildAmplitudeExperimentTrackingTrait';
export { BOT_SCORE_HUMAN_THRESHOLD, buildExperimentUserProperties, CF_BOT_SCORE_PROPERTY, isLikelyBot, } from './utils/buildExperimentUserProperties';
export { AMPLITUDE_OVERRIDE_COOKIE, parseAmplitudeOverrideCookie, } from './utils/parseAmplitudeOverrideCookie';
export { serializeAmplitudeExperiments } from './utils/serializeAmplitudeExperiments';
